<template>
  <div class="new-list" v-if="list.list?.length > 0">
    <div
      class="news-item"
      :class="{
        'item-arrows': type == 'arrows',
        'item-spot': type === 'spot',
        'item-dash': dash,
      }"
      v-for="(item, index) in list.list"
      :key="index"
      @click="toDetail(item,list.categoryCode)"
    >
      <div class="news-title">
        {{ item.articleName }}
      </div>
      <div class="news-time">
        {{ item.releaseTime }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "type", "dash"],
  data() {
    return {};
  },
  created() {},
  methods: {
    toDetail(item,code) {
      this.$emit("toDetail", item,code);
    },
  },
};
</script>

<style lang="scss" scoped>
.new-list {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  // min-height: 400px;
  .news-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;

    .news-title {
      flex: 1;
      display: -webkit-box;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      font-size: 16px;
    }
    .news-title:hover {
      color: #087cd6;
      cursor: pointer;
    }
    .news-time {
      margin-left: 20px;
      color: #999;
    }
  }
  .item-arrows::before {
    content: ">>";
    display: inline-block;
    font-size: 8px;
    font-weight: bold;
    // width: 6px;
    // height: 6px;
    // border-radius: 50%;
    color: #fc3027;
    margin-right: 8px;
  }
  .item-spot::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: black;
    margin-right: 8px;
  }
  .item-dash {
    border-bottom: 1px dashed #e6e6e6;
    padding: 8px 0;
  }
}
</style>
